import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
 apiKey: "AIzaSyAgDdRe9GeBPvW7TL6pq4w2UHfBBV6Uw8Y",

  authDomain: "deepk394449.firebaseapp.com",

  projectId: "deepk394449",

  storageBucket: "deepk394449.firebasestorage.app",

  messagingSenderId: "640925258050",

  appId: "1:640925258050:web:d54ff5774e91e22baaf8db",

  measurementId: "G-710CS485ZC"


};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Get a reference to the database service
export const database = getDatabase(app);
